// Browser's localStorage function

const ls = window.localStorage

/**
 * Wrapper function for localStorage.getItem
 *
 * Provides a JSON parsed version is it's anything anther than a string
 *
 * @param key - key to get desired local value
 * @returns - value of the key
 */

function get(key: string) {
	const item = ls.getItem(key)
	if (item) {
		return JSON.parse(item)
	}
	return item
}

/**
 * Wrapper function for localStorage.setItem
 *
 * Provides a way to automatically stringify the value
 *
 * @param key - key to set local value
 * @param value - value to set the key to
 * @returns - value of the key
 */

function set(key: string, value: any) {
	try {
		ls.setItem(key, JSON.stringify(value))
		return true
	} catch (e) {
		return false
	}
}

/**
 * Wrapper function for localStorage.removeItem
 *
 * Deletes the item from localStorage with the given key
 *
 * @param key - key to remove local value
 * @returns - value of the key
 */

function remove(key: string) {
	return ls.removeItem(key)
}

/**
 * Wrapper function for localStorage.clear
 *
 * Deletes the entire localStorage of the current domain.
 */

function clear() {
	return ls.clear()
}

/**
 * Custom Wrapper for browser's localStorage function.
 * It has some added functionality especially auto-matically stringify and parse the value.
 *
 * @param key - The key of the item to be stored.
 * @param value - The value of the item to be stored.
 * @returns {any} - Either the parsed value or the boolean decalring whether it was stored or not.
 */

function localStorage(key: string, value: any) {
	if (arguments.length === 1) {
		return get(key)
	}
	return set(key, value)
}

localStorage.set = set
localStorage.get = get
localStorage.remove = remove
localStorage.clear = clear

export default localStorage
